import {
  type CreateSourceImportBody,
  createSourceImport as createSourceImportRequest,
  fetchSourceImportsStatus as fetchSourceImportsStatusRequest,
  getSourceImport as getSourceImportRequest,
} from '@/features/uploads/api/imports';
import { toSourceImport } from '@/features/uploads/lib/transferModels';
import type { SourceImport, SourceImportStatusItem } from '@/features/uploads/types/uploads';
import type { ApiCallOptions } from '@/shared/api/client';

export async function createSourceImport(body: CreateSourceImportBody): Promise<SourceImport> {
  return toSourceImport(await createSourceImportRequest(body));
}

export async function getSourceImport(
  importId: string,
  options: ApiCallOptions = {},
): Promise<SourceImport> {
  return toSourceImport(await getSourceImportRequest(importId, options));
}

export async function fetchSourceImportsStatus(
  importIds: string[],
  options: ApiCallOptions = {},
): Promise<SourceImportStatusItem[]> {
  return (await fetchSourceImportsStatusRequest(importIds, options)).items;
}
